<template>
  <div class="props-group">
    <el-form-item label="禁止复制">
      <el-checkbox v-model="component.properties.disableCopy"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['component'],
  name: 'disable-copy'
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/disable-copy.vue